import { LEGEND_COLOR_MAP_NEW } from "../../constants";
import { generateLegend } from "./commonFunctions";
import { addClientLogoInFooter, heading1_css, heading1_text, heading2_css, heading2_text } from "./commonFunctions";
import { getPxToInch } from "../../util";

const getPercent = v => v / 100;

// Global setting: Hide text labels for segments below this percentage
const MIN_LABEL_PERCENTAGE = getPercent(4); // 3%

// PPtx With Direct Data Without DOM Manipulation
export function generateSegmentDriversPPT(dataArray, pptx, pres, isAppendices, type) {
  console.log('generateSegmentDriversPPT(dataArray==========', dataArray)

  const transformFormat = (current) => {
    return Object.entries(current).map(([title, children]) => ({
      title,
      data: Object.entries(children).map(([parentName, details]) => ({
        ...details,
        ParentDriverName: parentName
      }))
    }))
  }

  const dataArrayNew = transformFormat(dataArray.data.segmentData)
  const maxValue = Math.max(...dataArrayNew.flatMap(group => group.data.map(item => item.Percent)))

  const data = dataArrayNew.map(d => {
    const d1 = { ...d }
    d1.data = d1.data.map(item => {
      let rp = item.PositivePercent + item.NeutralPercent + item.MixedPercent + item.NegativePercent;
      return {
        ...item,
        RemainderPercent: maxValue - rp
      }
    })
    return d1;
  })

  const rect = { x: 0.57, y: 1.15, w: 12.47, h: 5.43 }
  const barHeight = 0.4750; // height per bar in inches 
  const maxBarsPerSlide = 11; // new threshold
  let columnWidthsArray = [2.5, rect.w - 2.5];

  const addDriverColumnFunc = (dataChunk, slide) => {
    const yOffsetParent = (rect.y + barHeight) + dataChunk.yPosi;
    dataChunk.data.forEach((item, index) => {
      const yOffset = yOffsetParent + index * barHeight;
      slide.addText(item.ParentDriverName, {
        x: rect.x,
        y: yOffset,
        w: columnWidthsArray[0],
        h: barHeight,
        fontSize: 12,
        fontFace: "Verdana",
        align: "left",
        color: "000000",
        bold: false,
      })
    })
  }

  const addGraphTotalValColumnFunc = (dataChunk, slide) => {
    let yOffsetParent = (rect.y + barHeight) + dataChunk.yPosi;
    let xOffsetParent = (rect.x + columnWidthsArray[0] + columnWidthsArray[1])
    let lineXOffsetParent = (rect.x + columnWidthsArray[0])
    dataChunk.data.forEach((item, index) => {
      const total = getPercent(item.Percent)
      let ratio = 0;
      if (columnWidthsArray.length === 2) {
        ratio = 0.255 / (maxValue / 36.4)
      }
      const xOffset = xOffsetParent - ((item.RemainderPercent) * ratio) - 0.6;
      const yOffset = yOffsetParent + index * barHeight;

      slide.addText(`${Math.round(total * 100)}%`, {
        x: xOffset,
        y: yOffset,
        w: 0.75,
        h: barHeight,
        fontSize: 10,
        fontFace: "Verdana",
        align: "left",
        color: "000000",
        bold: false,
      })

      slide.addShape(pptx.ShapeType.rect, {
        x: rect.x,
        y: yOffset,
        w: rect.w,
        h: barHeight,
        line: { color: '#E7E7E6', width: 1 },
      })
      slide.addShape(pptx.ShapeType.line, {
        x: lineXOffsetParent,
        y: yOffset,
        w: 0,
        h: barHeight,
        line: { color: '#E7E7E6', width: 1 },
      })
    })
  }

  const addStackBarGraphFunc = (pptxObj, slide, dataChunk) => {
    const nonReversedData = dataChunk.data.map(item => {
      const totalVal = getPercent(item.PositivePercent) + getPercent(item.NeutralPercent) +
                       getPercent(item.MixedPercent) + getPercent(item.NegativePercent)
      return {
        driver: item.DriverName,
        positive: getPercent(item.PositivePercent),
        neutral: getPercent(item.NeutralPercent),
        mixed: getPercent(item.MixedPercent),
        negative: getPercent(item.NegativePercent),
        remainder: getPercent(item.RemainderPercent),
        total: totalVal,
      }
    })
    
    const stackedData = [...nonReversedData].reverse(); // Chart data needs to be reversed

    const getBarColors = () => {
      return [
        (LEGEND_COLOR_MAP_NEW.Positive).replace('#',''),
        (LEGEND_COLOR_MAP_NEW.Neutral).replace('#',''),
        (LEGEND_COLOR_MAP_NEW.Mixed).replace('#',''),
        (LEGEND_COLOR_MAP_NEW.Negative).replace('#',''),
        'FFFFFF'
      ];
    }

    const yOffsetParent = (rect.y + barHeight) + dataChunk.yPosi;
    const widthParent = columnWidthsArray[1];
    const dataLabelColor = 'FFFFFF';

    // Calculate chart dimensions for manual label placement
    const chartStartX = rect.x + columnWidthsArray[0] + 0.1;
    const graphW = widthParent - 0.1;
    const maxValPct = getPercent(maxValue) + getPercent(4);
    const inchesPerPct = graphW / maxValPct;

    const options = {
      catAxisHidden: true,
      serAxisHidden: true,
      valAxisHidden: true,
      showGridLines: false,
      showVertGridLines: false,
      showDataTableHorzBorder: false,
      showDataTableVertBorder: false,
      showLeaderLines: false,
      layout: { x: 0, y: 0, h: 1 },
      chartColors: getBarColors(),
      valueBarColors: true,
      dataLabelFontFace: "Verdana",
      dataLabelFontSize: 10,
      dataLabelPosition: "r",
      valGridLine: { style: "none" },
      valAxisLineStyle: "dash",
      x: chartStartX,
      y: yOffsetParent,
      w: graphW,
      h: dataChunk.data.length * barHeight,
      barDir: "bar",
      barGrouping: "stacked",
      showLegend: false,
      showTitle: false,
      showValAxis: false,
      showCatAxis: false,
      showGridLines: false,
      showVertGridLines: false,
      showValue: false, // CRITICAL: Disable auto-labels
      valAxisMinVal: 0,
      valAxisMaxVal: maxValPct,
      dataLabelFormatCode: '#0%',
    }

    const labels = stackedData.map(d => d.driver)
    const chartData = [
      { name: "Positive", labels, values: stackedData.map(d => d.positive > 0 ? `${d.positive}` : '') },
      { name: "Neutral",  labels, values: stackedData.map(d => d.neutral > 0 ? `${d.neutral}` : '') },
      { name: "Mixed",    labels, values: stackedData.map(d => d.mixed > 0 ? `${d.mixed}` : '') },
      { name: "Negative", labels, values: stackedData.map(d => d.negative > 0 ? `${d.negative}` : '') },
      { name: "Remainder",labels, values: stackedData.map(d => d.remainder > 0 ? `${d.remainder}` : '') },
    ];

    slide.addChart(pptxObj.ChartType.bar, chartData, options)

    // --- MANUAL TEXT LABEL ADDITION START ---
    // Iterate over non-reversed data to match the slide's visual order (top to bottom)
    nonReversedData.forEach((item, barIndex) => {
        // Calculate the absolute Y position for the current bar
        const currentY = yOffsetParent + barIndex * barHeight;

        let accumulatedX = chartStartX; // Start X for the first segment
        
        const segments = [
            { value: item.positive, name: "Positive" },
            { value: item.neutral, name: "Neutral" },
            { value: item.mixed, name: "Mixed" },
            { value: item.negative, name: "Negative" },
        ];

        segments.forEach(segment => {
            if (segment.value > 0) {
                const segmentW = segment.value * inchesPerPct;
                const segmentText = `${Math.round(segment.value * 100)}%`;

                // Check against the global minimum percentage setting
                if (segment.value >= MIN_LABEL_PERCENTAGE) { 
                    slide.addText(segmentText, {
                        x: accumulatedX,
                        y: currentY,
                        w: segmentW, // Text box width matches bar segment width
                        h: barHeight,
                        fontSize: 10, 
                        fontFace: "Verdana",
                        align: "center", // Center text within the calculated width
                        color: dataLabelColor,
                        bold: false, 
                        valign: "middle",
                    });
                }
                // Update the starting X position for the next segment regardless of text visibility
                accumulatedX += segmentW;
            }
        });
    });
    // --- MANUAL TEXT LABEL ADDITION END ---

    addGraphTotalValColumnFunc(dataChunk, slide)
  }

  const groupByMaxSumObjs = (arr, maxSum) => {
    const result = [];
    let currentGroup = [];
    let currentSum = 0;
    let counter = 0;

    for (let obj of arr) {
      const num = obj.data.length;
      // We treat each chunk as having num rows + 1 for its title
      if (currentSum + num + 1 <= maxSum) {
        counter += (num + 1)
        currentGroup.push({ ...obj, count: counter })
        currentSum += (num + 1)
      } else {
        if (currentGroup.length > 0) {
          result.push(currentGroup)
          counter = 0;
        }
        counter += (num + 1)
        currentGroup = [{ ...obj, count: counter }];
        currentSum = (num + 1)
      }
    }

    if (currentGroup.length > 0) {
      result.push(currentGroup)
    }

    for (let i = 0; i < result.length; i++) {
      for (let j = 0; j < result[i].length; j++) {
        if (j === 0) {
          result[i][j].yPosi = 0;
        } else {
          result[i][j].yPosi = result[i][j - 1].count * barHeight;
        }
      }
    }

    return result;
  }

  const renderMerged = (chunks, index = 0, currentSlideData = []) => {
    if (index >= chunks.length) {
      if (currentSlideData.length > 0) {
        _renderSlideFromData(currentSlideData)
      }
      return;
    }

    const nextChunk = chunks[index];
    // count how many rows the nextChunk would add = its data length + 1 (title)
    const nextCount = nextChunk.reduce((sum, ch) => sum + ch.data.length + 1, 0)
    const currentCount = currentSlideData.reduce((sum, ch) => sum + ch.data.length + 1, 0)

    if ((currentCount + nextCount) <= maxBarsPerSlide) {
      currentSlideData.push(...nextChunk)
      return renderMerged(chunks, index + 1, currentSlideData)
    } else {
      _renderSlideFromData(currentSlideData)
      return renderMerged(chunks, index + 1, [...nextChunk])
    }
  }

  const _renderSlideFromData = (slideChunks) => {
    const slide = pptx.addSlide({ masterName: 'MASTER_SLIDE' })
    // add heading1 only once
    if (!slide._hasHeading1) {
      slide._hasHeading1 = true;
      slide.addText(heading1_text(dataArray.Title), heading1_css(dataArray.Title))
    }

    slideChunks.forEach((dataChunk, i) => {
      const yPosi = rect.y + dataChunk.yPosi;
      slide.addText(dataChunk.title, {
        x: rect.x,
        y: yPosi,
        w: rect.w,
        h: barHeight,
        fontSize: 14,
        fontFace: "Verdana",
        align: "left",
        color: "000000",
      })

      addDriverColumnFunc(dataChunk, slide)
      addStackBarGraphFunc(pptx, slide, dataChunk)
    })

    generateLegend(pptx, slide, 'Drivers', rect)
    addClientLogoInFooter(slide)
  }

  const renderAllSlide = () => {
    if (dataArray?.data?.percentSplit?.SegmentType && dataArray?.data?.percentSplit?.id?.length > 0) {
      if (!['SegmentDriversOnlyAnalysis3Level'].includes(type)) {
        const slide0 = pptx.addSlide({ masterName: 'MASTER_SLIDE' })
        spiderGraphFunc(pptx, slide0, dataArray, dataArray?.data?.percentSplit || {}, null, type)
      }
    }

    const chunks = groupByMaxSumObjs(data, maxBarsPerSlide)
    renderMerged(chunks)
  }

  renderAllSlide()
}

// unchanged spiderGraphFunc...
const spiderGraphFunc = (pptx, slide, dataArray, spiderData, dataUrl, type) => {
  if (spiderData?.id?.length > 0) {
    if (!['SegmentDriversOnlyAnalysis3Level'].includes(type)) {
      slide.addText(heading1_text(dataArray.Title), heading1_css(dataArray.Title))
      slide.addText(heading2_text(spiderData.SegmentType), heading2_css(spiderData.SegmentType))

      slide.addImage({ data: dataUrl, x: 1.0, y: 1.0, w: 6.0, h: 4.0 })

      const svgString1 = `${(document.getElementById(spiderData.id).innerHTML)
        .replace('<svg','<svg xmlns="http://www.w3.org/2000/svg" ')}`;
      const base641 = btoa(svgString1)
      const dataUri1 = `data:image/svg+xml;base64,${base641}`;
      slide.addImage({ data: dataUri1, x: 0.6, y: 1.4, w: getPxToInch(1000), h: getPxToInch(450) })
    }
  }
}
